<template>
    <v-list expand>
        <v-list-group
            :value="true"
            :ripple=false
            color="black"
        >
            <template v-slot:activator>
                <v-list-item-title>
                    <TitleFilter :filterType="filterType"/>
                </v-list-item-title>
            </template>
            <BadgeItems
                v-if="filterType === 'tag'"
                :filterType="filterType"
                :filterData="filterData"
                @filter-method="filterBy"
            />
            <TextItems
                v-else
                :filterType="filterType"
                :filterData="filterData"
                @filter-method="filterBy"
            />
        </v-list-group>
    </v-list>
</template>

<script>
    import TextItems from "@/components/filters/TextItems";
    import TitleFilter from "@/components/filters/TitleFilter";
    import BadgeItems from "@/components/filters/BadgeItems";

    export default {
        name: "CheckboxFilter",
        components: {
            TitleFilter,
            TextItems,
            BadgeItems
        },
        props: {
            filterData: {
                type: [Object, Array],
                required: true,
            },
            filterType: {
                type: String,
                required: true,
            }
        },
        methods: {
            filterBy(filter) {
                this.$emit('filter-method', filter);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-list-item__title {
        color: unset !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/filters/CheckboxFilter.vue